import { memo } from "react";
import { useElement, useLocale } from "../../../../hooks";
import { DashboardWidgetProps } from "../types";
import { useCarTotal } from "./hooks";
export const CarTotal = memo(({ data, action }: DashboardWidgetProps) => {
  const { t } = useLocale();
  const Input = useElement("Input");
  const Button = useElement("Button");
  const { applyFilters, setWidgetTitle, title, count } = useCarTotal({
    data,
    action,
  });

  const renderFilters = () => {
    return (
      <form onSubmit={applyFilters}>
        <Input
          onChange={setWidgetTitle}
          value={title}
          placeholder={t("widgetTitle")}
        />
        <Button
          type="submit"
          className="btn btn-primary hi-check-circle"
        ></Button>
      </form>
    );
  };

  return data.configure ? (
    renderFilters()
  ) : (
    <>
      <i className="widget-icon hi-car"></i>
      {count}
    </>
  );
});
